import { Star, Quote } from 'lucide-react';

const reviews = [
  {
    name: 'Fatima A.',
    rating: 5,
    text: 'Die Geschenkbox war wunderschön verpackt und kam rechtzeitig vor Eid an. Meine Schwiegermutter war begeistert!',
    product: 'Eid Geschenkbox',
    date: 'vor 2 Wochen',
  },
  {
    name: 'Ahmed K.',
    rating: 5,
    text: 'Endlich ein Shop, der unsere Bedürfnisse versteht. Hochwertige Produkte und toller Kundenservice.',
    product: 'Personalisierte Schmuckbox',
    date: 'vor 1 Woche',
  },
  {
    name: 'Leyla M.',
    rating: 5,
    text: 'Die Kinder haben sich riesig gefreut! Werde definitiv wieder bestellen. Eid Mubarak an das Team!',
    product: 'Eid Überraschungsbox Kinder',
    date: 'vor 3 Tagen',
  },
  {
    name: 'Omar B.',
    rating: 4,
    text: 'Sehr schöne Auswahl und schnelle Lieferung. Die Deko-Moschee ist ein echter Hingucker im Wohnzimmer.',
    product: 'Deko Gebetsnische',
    date: 'vor 1 Woche',
  },
];

export const SocialProofSection = () => {
  return (
    <section className="py-16 md:py-20 bg-[#FDFCF8]" data-testid="social-proof">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-1 mb-3">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />)}
          </div>
          <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E] mb-2">
            Das sagen unsere Kunden
          </h2>
          <p className="text-[#6B7280]">4.8 von 5 Sternen aus über 1.200 Bewertungen</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {reviews.map((review, i) => (
            <div key={i} className="bg-white rounded-2xl p-5 shadow-sm hover:shadow-md transition-shadow" data-testid={`review-${i}`}>
              <div className="flex items-center gap-0.5 mb-3">
                {[...Array(review.rating)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />)}
                {[...Array(5 - review.rating)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 text-gray-200" />)}
              </div>
              <Quote className="w-4 h-4 text-[#D4C5A9] mb-2" />
              <p className="text-sm text-[#4B5563] leading-relaxed mb-3">{review.text}</p>
              <div className="flex items-center justify-between pt-3 border-t border-[#F5F5F0]">
                <div>
                  <p className="text-xs font-medium text-[#2C332E]">{review.name}</p>
                  <p className="text-[10px] text-[#9CA3AF]">{review.product}</p>
                </div>
                <span className="text-[10px] text-[#9CA3AF]">{review.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
